import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTherapists, resetTherapists, reorderTherapists, updateTherapistOrder } from "../../redux/therapistSlice";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import UserPage from "../../common/UserPage/UserPage";
import Footer from "../../common/Footer/Footer";
import AdminTherapistInfo from "../../components/AdminTherapistInfo/AdminTherapistInfo";
import AdminSideBar from "../../common/AdminSideBar/AdminSideBar";

function AdminTherapistInfoPage() {
  const dispatch = useDispatch();
  const { therapists } = useSelector((state) => state.therapist);

  useEffect(() => {
    dispatch(resetTherapists());
    dispatch(getTherapists());
  }, [dispatch]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination, draggableId } = result;
    if (source.index === destination.index) return;

    // Önce UI'ı anında güncelle
    dispatch(reorderTherapists({ sourceIndex: source.index, destinationIndex: destination.index }));

    // Backend sadece sürüklenen terapisti yeni pozisyona alıp geri kalanı reindex yapıyor
    dispatch(updateTherapistOrder({ therapistId: draggableId, order: destination.index + 1 }))
      .unwrap()
      .then(() => dispatch(getTherapists())); // Sunucudan güncel sıralamayı al
  };

  return (
    <div>
      <UserPage />
      <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
        <div className="md:shrink-0 md:mr-6">
          <AdminSideBar />
        </div>
        <div className="m-2 mt-4 md:mt-10 mb-36 w-full pr-2 md:pr-4 lg:pr-6 overflow-y-auto bg-[#F7FAF7] rounded-xl p-4">
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="therapist-list">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {therapists.map((therapist, index) => (
                    <Draggable key={therapist._id} draggableId={therapist._id} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            opacity: snapshot.isDragging ? 0.85 : 1,
                          }}
                        >
                          <AdminTherapistInfo
                            therapistName={therapist.name}
                            therapistSurname={therapist.surname}
                            therapistTitle={therapist.title}
                            therapyPerformed={therapist.therapyPerformed}
                            fee={therapist.therapistDetail?.hourlyRate || therapist.therapistPayment?.hourlyPrice || therapist.hourlyPrice || 0}
                            imageSrc={therapist.picture}
                            therapistId={therapist._id}
                            isApprovedByAdmin={therapist.isApprovedByAdmin}
                            approvalStatus={therapist.approvalStatus}
                            isActive={therapist.isActive}
                            rating={therapist.rating}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AdminTherapistInfoPage;
